export default "__VITE_ASSET__C8n2hCFj__"